import { render, staticRenderFns } from "./DesignBadge.vue?vue&type=template&id=2ce6e1b7&"
import script from "./DesignBadge.vue?vue&type=script&lang=js&"
export * from "./DesignBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports